import { Matrix } from 'ml-matrix';
import { ensureSpinSystemProps } from '../utils/ensureSpinSystemProps';
function checkForMandatory(signals) {
    for (const signal of signals) {
        if (!signal.js)
            throw new Error('there is not js');
        if (!signal.atoms)
            throw new Error('there is not atoms');
        for (const jcoupling of signal.js) {
            if (!jcoupling.atoms)
                throw new Error('there is not atoms');
        }
    }
}
export function signalsToSpinSystem(signals) {
    checkForMandatory(signals);
    const nSpins = signals.length;
    const chemicalShifts = new Array(nSpins);
    const couplingConstants = Matrix.zeros(nSpins, nSpins);
    //create a list of assignments
    const ids = {};
    for (let i = 0; i < nSpins; i++) {
        chemicalShifts[i] = signals[i].delta;
        const index = signals[i].atoms[0];
        ids[index] = i;
    }
    //create the coupling matrix
    for (let i = 0; i < nSpins; i++) {
        const { atoms: signalAssignment, js: jCoupling } = signals[i];
        const fromIndex = signalAssignment[0];
        for (const jcoupling of jCoupling) {
            const { coupling, atoms } = jcoupling;
            const toIndex = atoms[0];
            couplingConstants.set(ids[fromIndex], ids[toIndex], coupling);
            couplingConstants.set(ids[toIndex], ids[fromIndex], coupling);
        }
    }
    return ensureSpinSystemProps({
        couplingConstants,
        chemicalShifts,
    });
}
//# sourceMappingURL=signalsToSpinSystem.js.map